export const getProductTitle = (item, lang = 'hy') => {
    if (!item) return '';
    const normLang = (lang || 'hy').slice(0, 2);
    if (normLang === 'en' && item['title_en']) {
        return item['title_en'];
    }
    if (normLang === 'ru' && item['title_ru']) {
        return item['title_ru'];
    }
    return item['title'] || '';
};

export const getProductContent = (item, lang = 'hy') => {
    if (!item) return '';
    const normLang = (lang || 'hy').slice(0, 2);
    if (normLang === 'en' && item['content_en']) {
        return item['content_en'];
    }
    if (normLang === 'ru' && item['content_ru']) {
        return item['content_ru'];
    }
    return item['content'] || '';
};

export const generateFullTitle = (item, lang = 'hy') => {
    if (!item) return '';
    const normLang = (lang || 'hy').slice(0, 2);

    if (normLang === 'en') {
        if (item['custom_full_title_en'] !== undefined) {
            return item['custom_full_title_en'];
        }
        const title = getProductTitle(item, 'en');
        if (item['custom_title_extension_en'] !== undefined) {
            return `${title} ${item['custom_title_extension_en']}`;
        }
        const isColored = item['colored'] !== 0;
        return `${isColored ? 'Color offset' : 'Offset'} and digital printing of ${title}`;
    }

    if (normLang === 'ru') {
        if (item['custom_full_title_ru'] !== undefined) {
            return item['custom_full_title_ru'];
        }
        const title = getProductTitle(item, 'ru');
        if (item['custom_title_extension_ru'] !== undefined) {
            return `${title} ${item['custom_title_extension_ru']}`;
        }
        const isColored = item['colored'] !== 0;
        return `${isColored ? 'Цветная офсетная' : 'Офсетная'} и цифровая печать: ${title}`;
    }

    // Armenian (default)
    if (item['custom_full_title'] !== undefined) {
        return item['custom_full_title'];
    }

    if (item['custom_title_extension'] !== undefined) {
        return item['title'] + item['custom_title_extension'];
    }

    let newTitle = item['title'] || '';

    // if newTitle ends with non-alphabetic (including unicode) character, add 'ի' before it
    if (newTitle.match(/[^\u0531-\u0587\u0561-\u0587a-zA-Z0-9]$/)) {
        // add 'ի' before the last character
        newTitle = newTitle.slice(0, -1) + 'ի' + newTitle.slice(-1);
    }
    else {
        // add 'ի' at the end
        newTitle = newTitle + 'ի';
    }

    if (item['colored'] !== 0) {
        newTitle = newTitle + ' գունավոր';
    }

    return newTitle + " օֆսեթ և թվային տպագրություն";
};